import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { DATADOG_RUM_SERVICE, DATADOG_RUM_SITE } from "components/common/constants";

export function initDatadogRum() {
  datadogRum.init({
    applicationId: `${process.env.REACT_APP_RUM_APPLICATION_ID}`,
    clientToken: `${process.env.REACT_APP_RUM_CLIENT_ID}`,
    site: DATADOG_RUM_SITE,
    service: DATADOG_RUM_SERVICE,
    env: `${process.env.REACT_APP_ENV}`,
    version: "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: true })],
  });
}
